export default "__VITE_ASSET__XzGT$Egz__"